import React from 'react';

const PayDutiesCallback = ({ match, location }) => {
  const status = match.params.status;
  const xltID = (location && location.state && location.state.xltID) || '';
  const hawb = (location && location.state && location.state.hawb) || '';
  console.log(`PayDutiesCallbackPage status=${status}, xltID=${xltID}, hawb=${hawb}`);

  function renderContent() {
    if (status === 'success') {
      return (
        <div className={`animated bounceIn status-payment-box ${status}`}>
          <div>
            <i className='glyphicon glyphicon-ok-circle' aria-hidden='true' />
          </div>
          {hawb
            ? `תשלום עבור ${hawb} הושלם בהצלחה!`
            : 'תשלום הושלם בהצלחה!'}
        </div>
      );
    }

    if (status === 'error') {
      return (
        <div className={`animated bounceIn status-payment-box ${status}`}>
          <div>
            <i className='glyphicon glyphicon-remove-circle' aria-hidden='true' />
          </div>
          {hawb
            ? `תשלום עבור ${hawb} לא הצליח.`
            : 'תשלום לא הצליח.'}
        </div>
      );
    }

    if (status === 'cancelled') {
      return (
        <div className='animated bounceIn status-payment-box success'>
          <div>
            <i className='glyphicon glyphicon glyphicon-info-sign' aria-hidden='true' />
          </div>
          {hawb
            ? `תשלום עבור ${hawb} בוטל.`
            : 'תשלום בוטל.'}
        </div>
      );
    }

    console.error(`Unexpected status ${status}`);
    return null;
  }

  return (
    <div className='payDuties'>
      {renderContent()}
    </div>
  );
};

export default PayDutiesCallback;
